import React from "react";
import { INDUSTRIES } from "../data/copperx";
import * as Icons from "lucide-react";

const HVAC_IMG =
  "https://images.unsplash.com/photo-1513257805917-a0da1146eb15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxodmFjJTIwY2hpbGxlciUyMGluZHVzdHJpYWwlMjBzaXRlfGVufDB8fHx8MTc4MDc1Mzg3Nnww&ixlib=rb-4.1.0&q=85";

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="bg-[#0a0a0b] text-white py-24 md:py-32 relative overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-15 bg-cover bg-center"
        style={{ backgroundImage: `url('${HVAC_IMG}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0b]/95 via-[#0a0a0b]/90 to-[#0a0a0b]" />
      <div className="absolute inset-0 grid-pattern opacity-40" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="section-rule" />
            <span className="text-[#E19672] text-xs tracking-[0.3em] uppercase font-semibold">
              Industries &amp; Applications
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05] mb-6">
            Trusted across the systems that <span className="copper-text">move air, water &amp; refrigerant.</span>
          </h2>
          <p className="text-[#94A3B8] text-lg leading-relaxed">
            From data-center chillers to medical gas piping and rooftop AHUs —
            our copper specifications are engineered for the demands of mission-critical infrastructure.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/10" data-testid="industries-grid">
          {INDUSTRIES.map((ind, idx) => {
            const Icon = Icons[ind.icon] || Icons.Box;
            return (
              <div
                key={ind.name}
                data-testid={`industry-card-${idx}`}
                className="bg-[#0a0a0b] hover:bg-[#18181B] p-6 md:p-8 transition-colors group cursor-default"
              >
                <Icon
                  size={28}
                  className="text-[#B85C38] mb-5 group-hover:scale-110 transition-transform"
                  strokeWidth={1.5}
                />
                <div className="text-white text-base md:text-lg font-medium leading-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
                  {ind.name}
                </div>
                <div className="mt-3 h-px w-8 bg-[#B85C38] group-hover:w-16 transition-all" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
